module.exports = __webpack_public_path__ + "img/twitter-icon.9e86a23e.svg";